import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/staking/")({
  beforeLoad: () => {
    throw redirect({
      to: "/staking/positions",
    });
  },
});
